import {
  Box,
  Button,
  Card,
  CardContent,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import axios from "axios";
import moment from "moment";
import React, { useState } from "react";

export default ({
  setSnackbar,
  dispatch,
  incomeStatementsRan,
  setIncomeStatementsRan,
}) => {
  let [email, setEmail] = useState("");
  let [postMonth, setPostMonth] = useState(1);
  let [postYear, setPostYear] = useState(moment().format("YYYY"));

  const runIncomeStatement = async () => {
    let headers = {
      "x-access-token": localStorage.getItem("token"),
    };

    try {
      await axios.post(
        "/run-income-statement",
        { email, postMonth, postYear },
        { headers }
      );
      dispatch(setSnackbar(true, "success", "Successfully posted batch."));
      let newStatementRan = [
        `${postMonth}-${postYear} for ${email}  @${moment().format(
          "HH:MM:SS"
        )}`,
      ];
      setIncomeStatementsRan(incomeStatementsRan.concat(newStatementRan));
    } catch (err) {
      dispatch(setSnackbar(true, "error", "Failed to post batch."));
    }
  };

  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  return (
    <Card>
      <CardContent>
        <Box sx={{ 
          maxWidth: 600, 
          mx: 'auto',
          p: 2
        }}>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <Typography variant="h6" gutterBottom>
                Generate Cash Income Statement
              </Typography>
            </Grid>
            
            <Grid item xs={12}>
              <TextField
                id="email"
                label="Email"
                type="text"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                fullWidth
                size="medium"
                variant="outlined"
                InputLabelProps={{
                  shrink: true,
                }}
                helperText="The statement will be sent to this email address"
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <FormControl fullWidth variant="outlined">
                <InputLabel id="post-month-label">Post Month</InputLabel>
                <Select
                  labelId="post-month-label"
                  id="postMonth"
                  value={postMonth}
                  onChange={(e) => setPostMonth(e.target.value)}
                  label="Post Month"
                >
                  {months.map((item, index) => (
                    <MenuItem value={index + 1} key={index}>
                      {item}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12} md={6}>
              <TextField
                id="py"
                label="Post Year"
                type="number"
                value={postYear}
                onChange={(e) => setPostYear(e.target.value)}
                fullWidth
                size="medium"
                variant="outlined"
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Grid>

            <Grid item xs={12}>
              <Box sx={{ 
                display: 'flex', 
                flexDirection: 'column',
                gap: 2,
                mt: 2 
              }}>
                <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                  <Button
                    disabled={email === "" || (postMonth === 0 && postYear === 0)}
                    onClick={runIncomeStatement}
                    variant="contained"
                    color="primary"
                    size="large"
                  >
                    Generate Statement
                  </Button>
                </Box>

                {incomeStatementsRan.length > 0 && (
                  <Box sx={{ 
                    mt: 3,
                    p: 2,
                    backgroundColor: 'background.paper',
                    borderRadius: 1,
                    boxShadow: 1
                  }}>
                    <Typography variant="subtitle2" color="text.secondary" gutterBottom>
                      Please allow 10 minutes for emails to be sent.
                    </Typography>
                    <Box sx={{ mt: 1 }}>
                      {incomeStatementsRan.map((text, index) => (
                        <Typography 
                          key={index} 
                          variant="body2" 
                          sx={{ 
                            py: 0.5,
                            color: 'text.primary'
                          }}
                        >
                          {index + 1}. {text}
                        </Typography>
                      ))}
                    </Box>
                  </Box>
                )}
              </Box>
            </Grid>
          </Grid>
        </Box>
      </CardContent>
    </Card>
  );
};
